import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { LawyerCardProfile } from '../../../../../lawyer/card/LawyerCardProfile';
import { EntitiesCardBody } from '../../../../../components/entities-card/EntitiesCardBody';
import { EntitiesCardFooter } from '../../../../../components/entities-card/EntitiesCardFooter';
import {
  LawyerSnippetFetcher,
  LawyerSnippetFetcherProps,
} from './LawyerSnippetFetcher';
import { LawyerSnippetTabs } from './LawyerSnippetTabs';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { Connect, PropsFromRedux } from './LawyerSnippetContainer';
import './lawyer_snippet.scss';
import { ResultsType } from '../../../../state/reducers/results.types';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { SnippetActions } from '../SnippetActions';

type Props = {
  lawyer: NonNullable<ResultsType['snippets']['professional']>;
} & UserContextType &
  WithRestrictedModalProps &
  PropsFromRedux;

export class RawLawyerSnippet extends React.Component<Props> {
  componentDidMount() {
    const { originalQueryKey, lawyer } = this.props;

    doctrineAnalytics('Search ProfessionalDisplayed', {
      lawyer_id: lawyer.lawyerId,
      query_key: originalQueryKey,
    });
  }

  shouldComponentUpdate(nextProps: Props) {
    return (
      nextProps.lawyer.lawyerId !== this.props.lawyer.lawyerId ||
      nextProps.isFilterToggled !== this.props.isFilterToggled
    );
  }

  handleClick = (source: string) => () => {
    const { accessPremium, openRestrictedModal } = this.props;
    if (!accessPremium) {
      openRestrictedModal(source);
    }
  };

  render() {
    const {
      lawyer,
      accessPremium,
      isFilterToggled,
      toggleLawyerFilter,
    } = this.props;

    return (
      <div className="lawyer-snippet">
        <EntitiesCardBody>
          <LawyerCardProfile
            lawyer={lawyer}
            onClick={this.handleClick('search-lawyer-snippet-header')}
            href={
              accessPremium
                ? `${lawyer.url}?source=search-lawyer-snippet-header`
                : undefined
            }
          />
        </EntitiesCardBody>
        <SnippetActions
          isToggled={isFilterToggled}
          handleToggleOn={() => toggleLawyerFilter(lawyer.lawyerId)}
          handleToggleOff={() => toggleLawyerFilter(undefined)}
        />
        <div className="lawyer-snippet__bottom">
          <LawyerSnippetFetcher lawyerId={lawyer.lawyerId}>
            {({ juridictions, villes, typologies }) =>
              juridictions.length > 0 ||
              villes.length > 0 ||
              hasTypologies(typologies) ? (
                <LawyerSnippetTabs
                  juridictions={juridictions}
                  villes={villes}
                  typologies={typologies}
                  lawyer={lawyer}
                  source="search-lawyer-snippet"
                />
              ) : null
            }
          </LawyerSnippetFetcher>
        </div>
        <EntitiesCardFooter
          onClick={this.handleClick('search-lawyer-snippet-footer')}
          href={
            accessPremium
              ? `${lawyer.url}?source=search-lawyer-snippet-footer`
              : undefined
          }
        >
          <FormattedMessage id="search/components/search-snippets/aside/lawyer/LawyerSnippet.tsx/1" />
        </EntitiesCardFooter>
      </div>
    );
  }
}

export const LawyerSnippet = Connect(
  withRestrictedModal(withUser(RawLawyerSnippet)),
);

function hasTypologies(typologies: LawyerSnippetFetcherProps['typologies']) {
  return !!typologies && typologies.datas.length > 0;
}
